import { render, staticRenderFns } from "./TaxonomySettings.vue?vue&type=template&id=12fc37b8&"
import script from "./TaxonomySettings.vue?vue&type=script&lang=ts&"
export * from "./TaxonomySettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports